import { createContext } from "react";

export const SmootherContext = createContext();
